/* eslint-disable max-len */

export default {
    name: 'AccountStatusTimeline',

    /**
     * @override
     */
    data() {
        return {
            accountHistoric: [],
            accountStatusStep: 0,
            statusToChange: {},
            statusesOptions: [
                {
                    keyOptions: ['REGISTERED_ONLINE', 'REGISTERED_EMAIL', 'REGISTERED_POSTAL', 'REGISTERED'],
                    key: 'REGISTERED',
                    date: null,
                    complete: true,
                    user: null
                },
                {
                    key: 'SIGNED',
                    date: null,
                    complete: true,
                    user: null
                },
                {
                    key: 'VALIDADO',
                    date: null,
                    complete: false,
                    user: null
                },
                {
                    key: 'ENVIADO',
                    date: null,
                    complete: false,
                    user: null
                },
                {
                    key: 'FINALIZED',
                    date: null,
                    complete: false,
                    user: null
                }
            ],
            statuses: []
        };
    },
    props: {
        account: {
            type: Object,
            required: true
        }
    },
    methods: {
        /**
         * Obtenemos la información relativa al historico del interviniente
         */
        fetchData() {
            const cfg = {};
            cfg.params = {};
            if (this.limit) {
                cfg.params.$limit = this.limit;
            }
            this.$accountsService.getAccountHistoric(this.account.uuid, cfg)
                .then(res => {
                    this.accountHistoric = res.data.accounts_historical;
                    this.accountHistoric.map(item => {
                        for (let index = 0; index < this.statuses.length; index++) {
                            const element = this.statuses[index];
                            if (element.key === item.status || (element.keyOptions && element.keyOptions.includes(item.status))) {
                                element.key = item.status;
                                element.date = item.created_on;
                                element.user = item.user_info;
                                element.complete = true;
                            }
                        }
                        return item;
                    });
                });
        },
        // si el estado firmado no tiene fecha significa que se ha saltado a validado y por lo tanto usamos la fecha de validación
        getSignedStatusDate(signedStatusDate) {
            if (!signedStatusDate) {
                const validatedStatus = this.statuses.find(status => ['VALIDATED', 'VALIDADO'].includes(status.key));
                return validatedStatus ? validatedStatus.date : undefined;
            }
            return signedStatusDate;
        }
    },
    /**
     * @override
     */
    mounted() {
        this.fetchData();
        this.statuses = this.statusesOptions;
        for (let i = 0; i < this.statuses.length; i++) {
            const element = this.statuses[i];
            if (element.key === this.account.status) {
                this.accountStatusStep = i;
            }
        }
    }
};
